import { useState } from 'react';

// Example custom hook to manage tooltip visibility
export function useCustomTooltip() {
  const [isVisible, setIsVisible] = useState(false);

  // Function to toggle visibility
  const toggleTooltip = () => {
    setIsVisible(!isVisible);
  };

  // Return the event handler and visibility state
  return {
    toggle: toggleTooltip,
    isVisible,
  };
}
